import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import messages from './messagesOrderSummary';
import inlineStyles from './styles';

const OrderSummaryBalance = ({
    classes, tableData = [], tableFooterData = [], preliminaryExchangeRecap = false, intl,
}) => (
    <Table>
        <TableHead>
            {preliminaryExchangeRecap
                ? (
                    <TableRow>
                        <TableCell colSpan="2">
                            <Typography variant="title" align="center" headlineMapping={{ title: 'h2' }}>
                                {intl.formatMessage(messages.preliminaryExchangeRecap)}
                            </Typography>
                        </TableCell>
                    </TableRow>
                ) : null}
            <TableRow>
                <TableCell className={classes.textColumn}>{intl.formatMessage(messages.item)}</TableCell>
                <TableCell className={classes.priceColumn}>{intl.formatMessage(messages.price)}</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {
                tableData.map((item) => (
                    <TableRow key={item.text}>
                        <TableCell id={`${item.id}_item`} className={classes.textColumn}>{item.text}</TableCell>
                        <TableCell id={`${item.id}_price`} className={classes.priceColumn}>{item.price}</TableCell>
                    </TableRow>
                ))
            }
            {
                tableFooterData.map((item) => (
                    <TableRow key={item.text}>
                        <TableCell id={`${item.id}_item`} className={classes.textColumn}>{item.text}</TableCell>
                        <TableCell id={`${item.id}_price`} className={classes.priceColumn}>{item.price}</TableCell>
                    </TableRow>
                ))
            }
        </TableBody>
    </Table>
);

OrderSummaryBalance.propTypes = {
    classes: PropTypes.object.isRequired,
    tableData: PropTypes.array,
    tableFooterData: PropTypes.array,
    preliminaryExchangeRecap: PropTypes.bool,
    intl: PropTypes.object,
};

// This alias will be used to access bare component for unit testing
export { OrderSummaryBalance as OrderSummaryBalanceAlias };

export default injectIntl(withStyles(inlineStyles)(OrderSummaryBalance));
